<template>
  <div>
    <img
      v-if="CheckImgUrl()"
      :style="{
        cursor: 'pointer',
        borderRadius: '10px',
        width: width,
        height: height,
      }"
      :src="imgUrl"
      alt=""
    />
    <div
      :style="{
        background: bgcolor,
        color: ftColor,
        width: width,
        height: height,
        lineHeight: height,
        marginTop: MarginTop,
      }"
      v-else
      class="userImage"
    >
      {{ username.substr(username.length - 1) }}
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    CheckImgUrl() {
      var ext = this.imgUrl.substr(this.imgUrl.lastIndexOf(".")).toLowerCase();
      if (this.exts.lastIndexOf(ext) >= 0) return true;
      return false;
    },
  },
  props: {
    width: {
      type: String,
      default: "40px",
    },
    MarginTop: {
      type: String,
      default: "10px",
    },
    height: {
      type: String,
      default: "40px",
    },
    bgcolor: {
      type: String,
      default: "#409EFF",
    },
    ftColor: {
      type: String,
      default: "#fff",
    },
    imgUrl: {
      type: String,
      require: true,
    },
    username: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      exts: [".png", ".jpg", ".gif", ".jpeg"],
    };
  },
};
</script>

<style scoped>
.userImage {
  cursor: pointer;
  border-radius: 10px;
  text-align: center;
}
</style>